/**
 * Work Management Service
 * Work tracking and management service API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { WorkItemRelationshipDto } from './workItemRelationshipDto';


export interface CreateWorkItemRequestDto { 
    /**
     * Work type element ID from reference-data-service
     */
    elementId: string;
    /**
     * Work item title
     */
    title: string;
    /**
     * Priority level
     */
    priority: CreateWorkItemRequestDto.PriorityEnum;
    /**
     * Detailed description
     */
    description?: string;
    /**
     * Rich text content for frontend display
     */
    content?: string;
    /**
     * Metadata validated against work type recordSchema
     */
    metadata?: any;
    /**
     * Due date for work item completion
     */
    dueDate?: string;
    /**
     * Parent work item ID if this is a subtask
     */
    parentWorkItemId?: string;
    /**
     * Patient ID if this work item is related to a specific patient
     */
    patientId?: string;
    /**
     * Optional relationships to create with other entities upon work item creation
     */
    relationships?: Array<WorkItemRelationshipDto>;
    /**
     * Whether to allow duplicate work items. If false (default), deduplication logic will be executed.
     */
    allowDuplicates?: boolean;
    /**
     * Target audience for this work item. Defaults to PROVIDER if not specified.
     */
    targetAudience?: CreateWorkItemRequestDto.TargetAudienceEnum;
}
export namespace CreateWorkItemRequestDto {
    export type PriorityEnum = 'low' | 'medium' | 'high' | 'urgent';
    export const PriorityEnum = {
        Low: 'low' as PriorityEnum,
        Medium: 'medium' as PriorityEnum,
        High: 'high' as PriorityEnum,
        Urgent: 'urgent' as PriorityEnum
    };
    export type TargetAudienceEnum = 'provider' | 'patient';
    export const TargetAudienceEnum = {
        Provider: 'provider' as TargetAudienceEnum,
        Patient: 'patient' as TargetAudienceEnum
    };
}


